'use strict';

var _ = require('lodash');
var StrategyElementService = function StrategyElementService(conditionsAndActionsService, StrategyCondition, StrategyAction) {
  var selection = {
    group: null,
    row: null,
    rowType: null,
    collection: null
  };
  function clearSelection() {
    selection.group = null;
    selection.row = null;
    selection.rowType = null;
    selection.collection = null;
  }
  function selectGroup(g, c) {
    selection.group = g;
    selection.row = null;
    selection.rowType = null;
    selection.collection = c;
  }
  function selectRow(g, r, c, t) {
    selection.group = g;
    selection.row = r;
    selection.collection = c;
    selection.rowType = t;
  }
  function getSelectedGroup() {
    return selection.group;
  }
  function getSelectedRowType() {
    return selection.rowType;
  }
  function isGroupSelected(g) {
    return g === undefined && selection.group !== null || g === selection.group;
  }
  function isRowSelected(r) {
    return r === undefined && selection.row !== null || r === selection.row;
  }
  function createCondition(params) {
    return new StrategyCondition(params || {});
  }
  function createAction(params) {
    return new StrategyAction(params || {});
  }
  function createGroup() {
    return {
      level: conditionsAndActionsService.getDefaultStrategyDomainLevel(),
      conditions: [createCondition()],
      actions: [createAction()]
    };
  }
  function getSelectedElement() {
    if (isRowSelected()) {
      return selection.row;
    } else if (isGroupSelected()) {
      return selection.group;
    }
  }
  function getCollection() {
    return selection.collection;
  }
  function createNewElement() {
    if (isRowSelected()) {
      return selection.rowType === 'actions' ? createAction() : createCondition();
    } else {
      return createGroup();
    }
  }
  function selectElement(element) {
    if (isRowSelected()) {
      selection.row = element;
    } else {
      selection.group = element;
    }
  }
  function createCopyOf(element) {
    if (!element) {
      return null;
    }
    if (element instanceof StrategyCondition || element instanceof StrategyAction) {
      return element.createCopy();
    }
    if (isGroup(element)) {
      return createGroupCopy(element);
    }
    return null;
  }
  function isGroup(element) {
    return element.conditions && element.actions;
  }
  function createGroupCopy(element) {
    var groupClone = {
      level: element.level,
      conditions: [],
      actions: []
    };
    groupClone.conditions = copyElements(element.conditions);
    groupClone.actions = copyElements(element.actions);
    return groupClone;
  }
  function copyElements(elements) {
    return _.chain(elements).transform(function (result, entry) {
      return result.push(entry.createCopy());
    }).value();
  }
  function isDuplicable() {
    return true;
  }
  return {
    selectGroup: selectGroup,
    selectRow: selectRow,
    isGroupSelected: isGroupSelected,
    isRowSelected: isRowSelected,
    getSelectedElement: getSelectedElement,
    getCollection: getCollection,
    getSelectedRowType: getSelectedRowType,
    getSelectedGroup: getSelectedGroup,
    createCondition: createCondition,
    selectElement: selectElement,
    createAction: createAction,
    createNewElement: createNewElement,
    clearSelection: clearSelection,
    createGroup: createGroup,
    createCopyOf: createCopyOf,
    isDuplicable: isDuplicable
  };
};
StrategyElementService.$inject = ['ConditionsAndActionsService', 'StrategyConditionFactory', 'StrategyActionFactory'];
module.exports = StrategyElementService;